
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/men-category/[category]/[childCategory]",
      function () {
        return require("private-next-pages/men-category/[category]/[childCategory]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/men-category/[category]/[childCategory]"])
      });
    }
  